import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';


export default class ScrollAnime{


    constructor(){
        this._init();
    }


    _init(){
        gsap.registerPlugin(ScrollTrigger);
    }


    _upboxAnime(){
        gsap.fromTo('.upbox__bgslide__overlay__inner',
            { autoAlpha: 0.3 },
            { autoAlpha: 0.5,
                scrollTrigger: {
                    trigger: '.upbox__bgslide__overlay',
                    start: 'top 20%',
                    end: 'bottom 100%',
                    scrub: 1.5,
                }
            }
        );
    }
}
